module.exports = __webpack_public_path__ + "assets/ic_pen.e9d76ea5.svg";